module.exports = __webpack_public_path__ + "media/log-out-mobile.5b293980.svg";